module.exports = __webpack_public_path__ + "static/media/image-3.37ad62f2.png";